const LOG_PREFIX = "[OCM][Custom] "
const Aniview = require('../../services/aniview')
let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    utils.contentLoaded().then(() => {
      runOutstream(utils)
      ocmGoneMadHb(utils)
    })

    window.oopb = () => {
      initVi(utils, document.querySelectorAll('.td-post-content > p')[2])
    }

    resolve(true)
  });
};

let runOutstream = (utils) => {
  (function (w, d, s) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }
    var ttag = function () {
      w.teads.page(96719).placement(104791, {
        slider: { allow_corner_position: false, allow_top_position: false },
        "css": "margin: 0px 0px 26px;",
        "format": "inread",
        "slot": { "selector": ".td-post-content > p", "minimum": 3 }
      }).passback(function () {
        // instream passback
        window.OCM.oipb = () => {
         ocmPassback(utils, document.querySelectorAll('.td-post-content > p')[3]);
        }
        
          utils.config.services.aniview.active = true
          const av = new Aniview(utils, utils.config)
          av.run()
        /*
        utils.config.services.instream.active = true
        const is = new Instream(utils, utils.config)
        is.run()
        */
        
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var protocol = w.location.protocol.match(/^https?:$/) ? w.location.protocol : 'https:';
      s.src = protocol + '//a.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    }
  })(window, document, document.createElement('script'));
}

let ocmPassback = (utils, selector) => {
  googletag.cmd.push(function() {
    if (selector) {
      inread_slot = googletag.defineSlot("/75351959,22645609195/militaire.gr/inread_pb", [[1, 1],[300,250],[336,280]],"ocm-outstream").addService(googletag.pubads());

      var outstream_div = document.createElement("div");
      outstream_div.id = "ocm-outstream";
      outstream_div.style.marginBottom = "21px";
      var outstream_script = document.createElement("script");
      outstream_script.text = 'googletag.cmd.push(function() { googletag.display("ocm-outstream"); if (ocmpbjs.hasOwnProperty("initAdServerSet")) { googletag.pubads().refresh([inread_slot]) } })';
      selector.parentNode.insertBefore(outstream_div, selector.nextElementSibling);
      outstream_div.append(outstream_script);
    }
  });
}

let initVi = (utils, slot) => {
  utils.loadStyle('#vi-stories-sponsor-container {display: none!important;}');

  var vidiv = document.createElement('div');
  vidiv.id = 'vi-div';
  if (!utils.is_mobile) {
    vidiv.style.width = '80%';
  }
  vidiv.style.margin = '0 auto';

  if (slot) {
    slot.parentNode.insertBefore(vidiv, slot.nextElementSibling);
  }

  (function (v, i) {
    var scp = v.createElement("script"),
        config = {
          ChannelID: '5d8390ef28a0611e523a52aa',
          AdUnitType: '2',
          PublisherID: '133044126840134',
          PlacementID: 'pltz9FljnNNm8YU6PEn',
          DivID: 'vi-div',
          IAB_Category: 'IAB1',
          Keywords: '',
          Language: 'en-us',
          BG_Color: '',
          Text_Color: '',
          Font: '',
          FontSize: '',
        };
    scp.src = 'https://s.vi-serve.com/tagLoader.js';
    scp.type = "text/javascript";
    scp.onload = function () {
      i[btoa('video intelligence start')].init(config);
    };
    (v.getElementsByTagName('head')[0] || v.documentElement.appendChild(v.createElement('head'))).appendChild(scp);
  })(document, window);
}



let ocmGoneMadHb = (utils) => {
  let waitForVariable = (utils.config.services.header_bidding.adsqRTDModuleEnabled) ? 'ADSQ' : 'ocmpbjs'
  console.log('waitForVariable', waitForVariable)
  utils.waitFor(waitForVariable, () => {
    console.log('ADSQ?', window.ADSQ)
    // inject a simple div
    let div = `<div id="ocm-gone-mad"></div>`
    let target = utils.doc_body || document.body
    target.insertAdjacentHTML('beforeEnd', div)

    let adunit = window.OCM.ad_units.filter((ad) => {
      return (ad.code === 'ocm-gone-mad')
    })[0]

    // Auction for it
    window.ocmpbjs.que.push(() => {
      window.ocmpbjs.addAdUnits({
        code: adunit.code,
        mediaTypes: adunit.mediaTypes,
        bids: adunit.bids,
      })

      window.ocmpbjs.requestBids({
        adUnitCodes: ['ocm-gone-mad'],
        bidsBackHandler: (bidResponses, timeout, auctionId) => {
          console.log('bidResponses', bidResponses)
          // filter out rejected bids
          Object.keys(bidResponses).forEach(adUnit => {
            bidResponses[adUnit].bids = bidResponses[adUnit].bids.filter(b => b.statusMessage !== 'bidRejected' && b.status !== 'bidRejected');
          });

          // filter out empty bids
          Object.keys(bidResponses).forEach(adUnit => {
            if (!bidResponses[adUnit].bids.length) {
              delete bidResponses[adUnit]
            }
          });

          if (Object.keys(bidResponses).length > 0) {
            console.log('bidResponses before directRenderBids', bidResponses)
            directRenderBids(bidResponses, utils)
          }
        },
        timeout: utils.config.services.header_bidding.bidderTimeout
      });
    })
  })
}

let directRenderBids = (bidResponses, utils) => {
  for (let adUnitCode in bidResponses) {
    if (utils.config.debug || utils.config.services.header_bidding.debug) {
      console.log(LOG_PREFIX + 'Found bid for #' + adUnitCode)
    }

    const divId = adUnitCode;
    const adDiv = window.document.getElementById(divId)

    if (adDiv) {
      if (utils.config.debug || utils.config.services.header_bidding.debug) {
        console.log(LOG_PREFIX + 'Ad div = ', adDiv)
      }

      let frmEl = window.document.createElement('iframe');

      frmEl.setAttribute('id', divId + '_ocm_hb')
      frmEl.setAttribute('style', 'border:0;overflow:hidden;margin:15px auto;display:block;');
      frmEl.scrolling = 'no'
      frmEl.width = '0'
      frmEl.height = '0'

      adDiv.appendChild(frmEl);

      let iframeDoc = frmEl.contentWindow.document
      let adServerTargeting = window.ocmpbjs.getAdserverTargetingForAdUnitCode(divId)
      //       if (utils.config.debug || utils.config.services.header_bidding.debug) {
      console.log(LOG_PREFIX + 'adServerTargeting', adServerTargeting)
      //       }

      // If any bidders return any creatives
      if (adServerTargeting && adServerTargeting['hb_adid']) {
        if (utils.config.debug || utils.config.services.header_bidding.debug) {
          console.log(LOG_PREFIX + 'Rendering ad for ' + divId)
        }
        window.ocmpbjs.renderAd(iframeDoc, adServerTargeting.hb_adid)
      }
    } else {
      if (utils.config.debug || utils.config.services.header_bidding.debug) {
        console.log(LOG_PREFIX + 'Ad div #' + divId + ' not found')
      }
    }
  }
}

module.exports = customCode;